module.exports = __webpack_public_path__ + "img/yz.b3cc4c06.png";